import React, { useEffect } from "react";
import { useAppSelector } from "../../../../infra/hooks";
interface PropsValue {
  setAllActions: (data: any) => void;
}
const DTOSalaryAdjustmentARModal = ({ setAllActions }: PropsValue) => {
  const stored_actions = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredActions
  );

  useEffect(() => {
    if (stored_actions) setAllActions(stored_actions);
  }, []);
  return <></>;
};

export default DTOSalaryAdjustmentARModal;
